import { createBrowserRouter } from 'react-router-dom'
import Root from '@/routes/root'
import ErrorPage from '@/components/error/error-page'
import { createAuthRoutes } from './factories/core/auth'
import { createCallbackRoutes } from './factories/core/callback'
import { createDashboardRoutes } from './factories/dashboard'
import { createRedirectRoutes } from './factories/redirects'
// NOTE: Legacy redirects (createLegacyRedirects) are disabled during transition.
// Both old feature-first URLs and new matter-first URLs work simultaneously.
// Enable redirects here when old routes are removed from dashboard.tsx.

/**
 * Creates the application's browser router with all route configurations.
 *
 * Route structure:
 * - / (Root)
 *   - Auth routes (sign-in, sign-up, forgot-password, invite, account-action, pending-subscription)
 *   - Dashboard routes (with all features nested)
 *   - Callback routes (subscription success)
 * - Top-level redirects (legacy URL migrations)
 */
export function createAppRouter() {
  return createBrowserRouter([
    {
      path: '/',
      element: <Root />,
      errorElement: <ErrorPage />,
      children: [...createAuthRoutes(), ...createDashboardRoutes(), ...createCallbackRoutes()],
    },
    ...createRedirectRoutes(),
  ])
}

/**
 * The application's router instance.
 * Export for use in main.tsx and navigation utilities.
 */
export const router = createAppRouter()
